// NOTE: THIS IS THE OLD COMMISSION PLANS PORTED FROM FM2!  Use CommissionPlanTemplate from now on.

import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  commissionPlan: null,
  commissionPlans: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const commissionPlanReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.COMMISSIONPLAN_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.COMMISSIONPLAN_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.COMMISSIONPLAN_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default commissionPlanReducer;
